import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-db29f59c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "col-12 grid" }
const _hoisted_2 = { class: "m-auto p-0" }
const _hoisted_3 = { class: "m-auto p-0" }
const _hoisted_4 = { class: "col-5 p-0 flex" }
const _hoisted_5 = {
  class: "col p-0 flex",
  style: {"margin-left":"4px"}
}
const _hoisted_6 = { class: "col-12 flex align-content-center justify-content-center p-0 m-0" }

import { Result } from "@/interfaces/Result";
import { computed } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'UsaResultBoard',
  props: {
    results: {},
    tod: {},
    inline: { type: Boolean },
    isToday: { type: Boolean },
    icon: {},
    todHeight: {},
    boloSize: {},
    time: {}
  },
  setup(__props: any) {

const props = __props;



const tm = computed(() => (props.time ? (props.time.length ? props.time[0] : "") : ""));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "col-12 flex bg-black-alpha-90 text-white tod p-0",
      style: _normalizeStyle([{"margin":"0 0 2px 0"}, { height: `${_ctx.todHeight}px`, fontSize: `${_ctx.todHeight * 0.5}px` }])
    }, [
      _createElementVNode("i", {
        class: _normalizeClass([_ctx.icon, "m-auto p-0"])
      }, null, 2),
      _createElementVNode("strong", _hoisted_2, _toDisplayString(_ctx.tod), 1),
      _createElementVNode("span", _hoisted_3, _toDisplayString(tm.value), 1)
    ], 4),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.results, (result, i) => {
      return (_openBlock(), _createElementBlock(_Fragment, { key: i }, [
        (_ctx.inline)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("span", {
                  class: "ml-auto my-auto mr-0 font-semibold",
                  style: _normalizeStyle({ fontSize: `${_ctx.todHeight * 0.65}px` })
                }, _toDisplayString(result.name), 5)
              ]),
              _createElementVNode("div", _hoisted_5, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(result.numbers, (number, j) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: _normalizeClass(["border-circle flex", { 'bg-green-500': number !== null && _ctx.isToday, 'bg-red-500 text-white': number !== null && !_ctx.isToday, 'surface-500': number === null }]),
                    style: _normalizeStyle([{"margin-left":"1px","margin-right":"1px"}, { height: `${_ctx.boloSize}px`, width: `${_ctx.boloSize}px` }]),
                    key: j
                  }, [
                    _createElementVNode("span", {
                      class: "m-auto font-bold",
                      style: _normalizeStyle({ fontSize: `${_ctx.boloSize * 0.65}px` })
                    }, _toDisplayString(number), 5)
                  ], 6))
                }), 128))
              ])
            ], 64))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createElementVNode("div", {
                class: "col-12 flex align-content-center justify-content-center p-0 m-0 font-semibold",
                style: _normalizeStyle({ fontSize: `${_ctx.todHeight * 0.65}px` })
              }, _toDisplayString(result.name), 5),
              _createElementVNode("div", _hoisted_6, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(result.numbers, (number, j) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: _normalizeClass(["border-circle flex", { 'bg-green-500': number !== null && _ctx.isToday, 'bg-red-500 text-white': number !== null && !_ctx.isToday, 'surface-500': number === null }]),
                    style: _normalizeStyle([{"margin-left":"1px","margin-right":"1px"}, { height: `${_ctx.boloSize}px`, width: `${_ctx.boloSize}px` }]),
                    key: j
                  }, [
                    _createElementVNode("span", {
                      class: "m-auto font-bold",
                      style: _normalizeStyle({ fontSize: `${_ctx.boloSize * 0.65}px` })
                    }, _toDisplayString(number), 5)
                  ], 6))
                }), 128))
              ])
            ], 64))
      ], 64))
    }), 128))
  ]))
}
}

})